import { Page } from 'compositions/Page'

import { SubscriptionTopicsSection } from '../settings/subscription-topics-section'

export function AdminTopics() {
  return (
    <Page>
      <h1 className="mb-6 text-xl font-semibold">Subscription Topics</h1>
      <SubscriptionTopicsSection />
    </Page>
  )
}
